import { createFileRoute } from "@tanstack/react-router";

import { SpacesList } from "../features/console";

export const Route = createFileRoute("/console/spaces/")({
  component: SpacesList,
});
